import { render, staticRenderFns } from "./NeList.vue?vue&type=template&id=2e964596&scoped=true&"
import script from "./NeList.vue?vue&type=script&lang=js&"
export * from "./NeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e964596",
  null
  
)

export default component.exports